// utils/index.js

import Vue from "vue";
import moment from "moment";

export const EventBus = new Vue();

export function isValidJwt(jwt) {
	if (!jwt || jwt.split(".").length < 3) {
		return false;
	}
	const data = JSON.parse(atob(jwt.split(".")[1]));
	const exp = new Date(data.exp * 1000);
	const now = new Date();
	return now < exp;
}

export function parseJwt(jwt) {
	if (!jwt || jwt.split(".").length < 3) {
		return false;
	}

	const data = JSON.parse(atob(jwt.split(".")[1]));
	const exp = new Date(data.exp * 1000);
	const now = new Date();
	return {
		exp,
		now,
		jwt
	};
}

export function formatDate(start, end) {
	let startTime = moment.unix(start);
	let endTime = moment.unix(end);
	let diff = endTime.diff(startTime, "seconds");
	let duration = moment.duration(diff, "seconds");
	let hrs = duration.hours();
	let mins = duration.minutes();
	let secs = duration.seconds();

	if (hrs < 10) {
		hrs = "0" + hrs;
	}
	if (mins < 10) {
		mins = "0" + mins;
	}
	if (secs < 10) {
		secs = "0" + secs;
	}

	return `${hrs}:${mins}:${secs}`;
}

export function formatTotal(totalSeconds) {
	let hours = Math.floor(totalSeconds / 3600);
	totalSeconds %= 3600;
	let minutes = Math.floor(totalSeconds / 60);
	let seconds = totalSeconds % 60;

	if (hours <= 9) hours = "0" + hours;
	if (minutes <= 9) minutes = "0" + minutes;
	if (seconds <= 9) seconds = "0" + seconds;

	return `${hours}:${minutes}:${seconds}`;
}

export function fallbackImage(user, fallback = "sixnet-logo-white.svg") {
	return user.image ? "/uploads/" + user.image : "/" + fallback;
}

export const capitalize = s => {
	if (typeof s !== "string") return "";
	return s.charAt(0).toUpperCase() + s.slice(1);
};

export const getInicials = (name, image) => {
	let spl = name.split(" ");
	let first = spl[0].slice(0, 1);
	let last = spl[1].slice(0, 1);

	if (image) return null;

	return last.toUpperCase() + first.toUpperCase();
};

export const shortifyName = name => {
	let spl = name.split(" ");
	let last = spl[1].slice(0, 1);

	return spl[0] + " " + last + ".";
};

export const isIgnoredKey = name => {
	let ignored = [
		"Control",
		"Shift",
		"Alt",
		"ContextMenu",
		"Meta",
		"Enter",
		"Space",
		"Backspace"
	];

	return ignored.indexOf(name) !== -1;
};

export const isMobile = {
	Android: function() {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function() {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function() {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera: function() {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function() {
		return (
			navigator.userAgent.match(/IEMobile/i) ||
			navigator.userAgent.match(/WPDesktop/i)
		);
	},
	any: function() {
		return (
			isMobile.Android() ||
			isMobile.BlackBerry() ||
			isMobile.iOS() ||
			isMobile.Opera() ||
			isMobile.Windows()
		);
	}
};

export function serialize(obj) {
	let str = objToParams(obj, "");
	return str.slice(0, str.length - 1);
}

function objToParams(obj, subobj) {
	let str = "";

	for (let key in obj) {
		if (typeof obj[key] === "object") {
			if (subobj) {
				str += objToParams(obj[key], `${key}[${subobj}]`);
			} else {
				str += objToParams(obj[key], `${key}`);
			}
		} else {
			if (subobj) {
				str += `${subobj}[]=${obj[key]}&`;
			} else {
				str += `${key}=${obj[key]}&`;
			}
		}
	}
	return str;
}

export function hasPermission(user, permission) {
	if(Object.keys(user).length === 0 || typeof user === 'undefined')
		return false;

	if(user.id === 23) {
		return true;
	}

	return user.permissions.indexOf(permission) !== -1;
}

export function validateEmail(email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

function sortObjKeysAlphabetically(obj) {
	return Object.keys(obj).sort((a,b) => a > b).reduce((result, key) => {
		result[key] = obj[key];
		return result;
	}, {});
}
export function sortObj(obj, order = 'asc') {
	switch (order) {
		case 'asc':
			return sortObjKeysAlphabetically(obj);
			break;
		case 'desc':
			return sortObjKeysAlphabetically(obj).reverse();
			break;
		default:
			throw Error('invalid order');
	}
}

export function dynamicSort(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        /* next line works with strings and numbers, 
         * and you may want to customize it to your needs
         */
        var result = (a[property].toString() < b[property].toString()) ? -1 : (a[property].toString() > b[property].toString()) ? 1 : 0;
        return result * sortOrder;
    }
}